import React, { useEffect, useState, useRef } from 'react';
import client from '../../sanity/client';
import '../Chemin/CheminPage.scss';
import { ArrowLeft, ArrowRight } from '../../assets/svg';
import { useLanguage } from '../../components/LanguageContext';
import SubPageBols from "../Ceramiste/SubPageBols";
import SubPageChawans from "../Ceramiste/SubPageChawans";

const CeramistePage = () => {
  const [data, setData] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { language } = useLanguage();

  const intervalRef = useRef(null);
  
  // Lancer ou relancer l'auto-défilement
  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % (data?.carrousel?.length || 1));
    }, 3000);
  };

  const resetAutoSlide = () => {
    startAutoSlide();
  };

  useEffect(() => {
    const fetchData = async () => {
      const query = `*[_type == "ceramiste"][0]{
        title,
        carrousel[]{ "imageUrl": asset->url + "?auto=format" },
        colonneGauche,
        colonneDroite
      }`;
      const result = await client.fetch(query);
      setData(result);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data?.carrousel?.length > 0) {
      startAutoSlide();
    }
    return () => clearInterval(intervalRef.current);
  }, [data]);

  const goToNextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % data.carrousel.length);
    resetAutoSlide();
  };

  const goToPrevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + data.carrousel.length) % data.carrousel.length);
    resetAutoSlide();
  };

  if (!data) return <div>Loading...</div>;

  return (
    <>
      <div className="chemin-page titre-page">
        <h1 className="chemin-text" data-aos="fade-in" data-aos-duration="800">
          {data.title[language]}
        </h1>

        {data.carrousel?.length > 0 && (
          <div className="carousel" data-aos="fade-in" data-aos-duration="1000" data-aos-delay="200">
            <div className="carousel-image-container">
              {data.carrousel.map((image, index) => (
                <img
                  key={index}
                  src={image.imageUrl}
                  alt={`Slide ${index + 1}`}
                  className={`carousel-image ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div>

            <div className="carousel-controls">
              <button className="carousel-control prev" onClick={goToPrevSlide}>
                <ArrowLeft />
              </button>
              <button className="carousel-control next" onClick={goToNextSlide}>
                <ArrowRight />
              </button>
            </div>
          </div>
        )}
      </div>

      <section className='text_section'>
        <div className='text_parts'>
          <div className="text_content_left" data-aos="fade-right" data-aos-duration="800" data-aos-delay="100">
            {data.colonneGauche?.[language]?.map((paragraph, idx) => (
              <p key={idx} data-aos="fade-in" data-aos-duration="600" data-aos-delay={200 + (idx * 100)}>
                {paragraph.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            ))}
          </div>
          <div className="text_content_right" data-aos="fade-left" data-aos-duration="800" data-aos-delay="100">
            {data.colonneDroite?.[language]?.map((paragraph, idx) => (
              <p key={idx} data-aos="fade-in" data-aos-duration="600" data-aos-delay={200 + (idx * 100)}>
                {paragraph.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            ))}
          </div>
        </div>
      </section>
      
      <section className="ceramiste_bols_chawan" data-aos="fade-in" data-aos-duration="800" data-aos-delay="100">
        <SubPageBols />
      </section>
      
      <section className="ceramiste_bols_chawan" data-aos="fade-in" data-aos-duration="800" data-aos-delay="300">
        <SubPageChawans />
      </section>
    </>
  );
};

export default CeramistePage;